import uuid from "react-uuid";
import { formEl } from "../../../../constants";
import { LuCopy, LuGripVertical, LuTrash2 } from "react-icons/lu";
import input from "../input.module.css";
import ImageSelect from "../../../../Components/ImageSelect/ImageSelect.jsx";
const CheckboxInput = ({
  item,
  handleValue,
  deleteEl,
  handleRequired,
  handleElType,
  addOption,
  handleOptionValues,
  deleteOption,
  duplicateElement,
  disableDelete,
  isPreview = false,
}) => {
  const createNewOption = (id) => {
    const data = {
      id: uuid(),
      value: "",
    };
    addOption(id, data);
  };

  return (
    <div className="bg-white drag-handle border border-gray-200 rounded-lg shadow-sm mb-4">
      <div className="text-center py-2 cursor-move">
        <LuGripVertical className="inline-block text-gray-400" size={20} />
      </div>
      <div className="px-6 space-y-4 py-4">
        <div className="w-[300px]">
          <ImageSelect
            value={item.type}
            onChange={(value) => handleElType(item.id, value)}
            options={formEl}
            className={`${input.input_field} w-full`}
            disabled={isPreview}
          />
        </div>
        <div className="flex gap-2">
          <div className="flex-1">
            <input
              type="text"
              defaultValue={item.value}
              onBlur={(e) => !isPreview && handleValue(item.id, e)}
              placeholder="Question"
              required={item.required}
              className="w-full px-3 py-2 mb-3 border-b border-[#D9E9DA] focus:border-[#4B664C] focus:outline-none text-sm"
              disabled={isPreview}
            />
            {item.options &&
              item.options.length > 0 &&
              item.options.map((opt, key) => (
                <div key={opt?.id} className="flex items-center gap-2 mb-2">
                  <div className="flex items-center gap-2 flex-1">
                    <input type="checkbox" disabled className="w-4 h-4" />
                    <input
                      type="text"
                      placeholder="Placeholder"
                      defaultValue={opt?.value}
                      onBlur={(e) =>
                        !isPreview &&
                        handleOptionValues(item?.id, opt?.id, e.target.value)
                      }
                      className="flex-1 px-3 py-2 border-b border-[#D9E9DA] focus:border-[#4B664C] focus:outline-none text-sm"
                      disabled={isPreview}
                    />
                  </div>
                  <button
                    onClick={() => deleteOption(item.id, opt?.id)}
                    className="text-red-500 hover:text-red-700 p-1"
                    title="Delete Option"
                    disabled={disableDelete || isPreview}
                  >
                    <LuTrash2 size={16} />
                  </button>
                </div>
              ))}
            <button
              onClick={() => createNewOption(item.id)}
              className="text-[#4B664C] text-sm mt-2"
              disabled={isPreview}
            >
              Add option
            </button>
          </div>
        </div>
      </div>
      <hr className="border-gray-200" />
      <div className="flex items-center px-4 py-2 gap-4">
        <button
          onClick={() => deleteEl(item.id)}
          className="text-red-500 hover:text-red-700 p-2"
          title="Delete Element"
          disabled={disableDelete || isPreview}
        >
          <LuTrash2 size={18} />
        </button>
        <button
          onClick={() => duplicateElement(item.id, item.type)}
          className="text-gray-600 hover:text-gray-800 p-2"
          title="Duplicate Element"
          disabled={isPreview}
        >
          <LuCopy size={18} />
        </button>
        <label className="flex items-center gap-2 ml-auto cursor-pointer">
          <input
            type="checkbox"
            checked={item.required}
            onChange={() => handleRequired(item.id)}
            className="w-4 h-4"
            disabled={isPreview}
          />
          <span className="text-sm">Compulsory</span>
        </label>
      </div>
    </div>
  );
};

export default CheckboxInput;
